import { runDemo } from "../shared/demoRunner";
import { createTrainScene } from "./scene";

runDemo({ createScene: createTrainScene });
